/** @jsxImportSource @emotion/react */
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { MutateStoreForm } from "../components/MutateStoreForm";

export const NewStorePage = () => {
  return (
    <RouteFullScreenModal title="New store">
      <Divider />
      <MutateStoreForm />
    </RouteFullScreenModal>
  );
};
